// extracted by mini-css-extract-plugin
module.exports = {"Container":"Page_Container__J1U_c","LeftCol":"Page_LeftCol__ohBbq"};